import { Component, Input, OnInit } from '@angular/core';
import IPRTreadData = ZoningAPI.IPRTreadData;

@Component({
    standalone: false,
    selector: 'app-pr-threads-list',
    templateUrl: './pr-threads-list.component.html',
    styleUrls: ['./pr-threads-list.component.scss', '../../../../../shared/styles/mdl-table.scss']
})
export class PrThreadsListComponent implements OnInit {
    @Input()
    prThreadsData: IPRTreadData[];

    constructor() {}

    ngOnInit() {}
}
